import {KTIcon} from '../../../../_metronic/helpers'


const ExtendModalHeader = ({setSelectedBookingId, selectedBookingId, setOpenExtendModal}) => {


  return (
    <div className='modal-header'>
      <h2 className='fw-bolder'> Extend Booking For Booking Number #{selectedBookingId.booking_id}</h2>
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-users-modal-action='close'
        onClick={() =>  {
          setSelectedBookingId(null)
          setOpenExtendModal(false)
        }}
        style={{cursor: 'pointer'}}
      >
        <KTIcon iconName='cross' className='fs-1' />
      </div>

    </div>
  )
}

export {ExtendModalHeader}
